import React from "react";
import {Draggable} from "react-beautiful-dnd";
import {useSelector} from "react-redux";
import {Icon, IconButton, makeStyles, Typography} from "@material-ui/core";
import {multiLanguageValue} from "../../../../../Utils/lib";

const useStyles = makeStyles(theme => ({
    choiceItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.02)',
        width: '100%',
        padding: 10,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        '&:hover': {
            '& $actionsContainer': {
                visibility: 'visible'
            },
            '& $removeButtonContainer': {
                visibility: 'visible'
            }
        }
    },
    removeButtonContainer: {
        display: "flex",
        visibility: 'hidden'
    }
}))

const ChoiceItem = (props) => {
    const {choice, index, removeGroup, onEdit} = props;
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    return (
        <Draggable draggableId={choice.id + "_" + index} index={index} key={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    key={index}
                    className={classes.choiceItem}>

                    <div style={{width: '33.3%'}}>
                        <Typography>{choice.id}</Typography>
                    </div>
                    <div style={{width: '33.3%'}}>
                        <Typography>{multiLanguageValue(choice.label, userLanguage)}</Typography>
                    </div>
                    <div style={{width: '33.3%'}}>
                        <Typography>{choice.points}</Typography>
                    </div>
                    <div className={classes.removeButtonContainer}>
                        <IconButton size={'small'} onClick={() => {
                            removeGroup(index)
                        }}>
                            <Icon fontSize={"small"}>
                                highlight_off
                            </Icon>
                        </IconButton>
                        <IconButton size={'small'} onClick={() => {
                            onEdit(index)
                        }}>
                            <Icon fontSize={"small"}>
                                edit
                            </Icon>
                        </IconButton>
                    </div>
                </div>
            )}
        </Draggable>
    )
}
export default ChoiceItem